/** @jsxImportSource preact */
import * as preact from 'preact';
// Generated by make before bundling; importing this never pulls in the full stats data.
import navigationJSON from '../../html/data/unit-navigation.json';
import type { UnitNavigationGroup } from '../../source-data/data-types';
import { unitToken as token } from '../../source-data/unit-token';
import type { Token } from '../../source-data/unit-token';

export const unitNavigation = navigationJSON as UnitNavigationGroup[];

export function unitPageTitle(commander?: string, unit?: string): string {
    const group = unitNavigation.find(group => group.id === commander);
    const groupName = group && (group.amon ? `Amon ${group.name}` : group.name);
    const unitName = group?.units.find(entry => entry.id === unit)?.name;
    const selection = unitName ? `${unitName} (${groupName})` : groupName;
    return `${selection ? `${selection} - ` : ''}Units - SC2 Co-op`;
}

export class CommanderSelector extends preact.Component<{ commander: string | null }> {
    override render() {
        return <td class="units-commander-selector">
            {[false, true].map(amon => <preact.Fragment key={String(amon)}>
                <p class="units-head">{amon ? 'Amon' : 'Commanders'}</p>
                <ul class="units-nav">
                    {unitNavigation.filter(group => group.amon === amon).map(group => <li key={group.id}>
                        <a href={`#${group.id}`} aria-selected={this.props.commander === group.id ? true : undefined}>
                            {!amon && <img src={`/images/commanderportraits/${group.id}portrait.png`} alt="" width="25" height="25" />}
                            {group.name}
                        </a>
                    </li>)}
                </ul>
            </preact.Fragment>)}
        </td>;
    }
}

export class UnitSelector extends preact.Component<{ commander: Token | null, unit: Token | null, onClickUnit: (event: MouseEvent) => void }> {
    renderLink(name: string): preact.ComponentChildren {
        const unit = token(name);
        return <li key={unit}><a href={`#${this.props.commander}/${unit}`} aria-selected={this.props.unit === unit ? true : undefined} onClick={this.props.onClickUnit}>
            {name}
        </a></li>;
    }
    override render() {
        if (this.props.commander === null) {
            return <td class="units-unit-selector"><p><big>&larr;</big> Select a commander</p></td>;
        }
        const units = unitNavigation.find(group => group.id === this.props.commander)?.units.filter(unit => !unit.hidden) ?? [];
        return <td class="units-unit-selector">
            {(['Units', 'Heroes', 'Structures'] as const).flatMap(category => {
                const entries = units.filter(unit => unit.category === category);
                return entries.length ? [
                    <p class="units-head" key={`${category}-heading`}>{category}</p>,
                    <ul class="units-nav" key={category}>{entries.map(unit => this.renderLink(unit.name))}</ul>,
                ] : [];
            })}
        </td>;
    }
}
